module.exports = __webpack_public_path__ + "static/media/s4.aa70737e.png";